(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  if (!customElements.get('horizon-blog-auto-load')) {
    customElements.define('horizon-blog-auto-load', class extends HTMLElement {
      connectedCallback() {
        // Theme JavaScript is deferred, so the section markup is available here.
        this.grid = this.querySelector('[data-blog-grid]');
        this.pagination = this.querySelector('[data-blog-pagination]');
        this.status = this.querySelector('[data-blog-status]');
        if (!this.grid || !this.pagination || !this.status) return;
        this.loading = false;
        this.onClick = (event) => {
          const link = event.target.closest('[data-blog-next]');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.loadNext(true);
        };
        this.pagination.addEventListener('click', this.onClick);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.loadNext(false);
          }, { rootMargin: '0px 0px 300px 0px' });
          this.observeNext();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.pagination?.removeEventListener('click', this.onClick);
      }

      observeNext() {
        this.observer?.disconnect();
        const link = this.pagination.querySelector('[data-blog-next]');
        if (link) this.observer?.observe(link);
      }

      async loadNext(manual) {
        const link = this.pagination.querySelector('[data-blog-next]');
        if (this.loading || !link) return;
        this.loading = true;
        this.observer?.disconnect();
        this.grid.setAttribute('aria-busy', 'true');
        link.setAttribute('aria-disabled', 'true');
        this.status.textContent = 'Loading more posts…';
        const controller = new AbortController();
        this.controller = controller;
        const timeout = setTimeout(() => controller.abort(), 20000);
        let success = false;
        try {
          const url = new URL(link.href, window.location.href);
          url.searchParams.set('section_id', this.getAttribute('section-id'));
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Unable to load posts');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!this.isConnected || this.controller !== controller) return;
          const section = Array.from(doc.querySelectorAll('horizon-blog-auto-load')).find(
            (element) => element.getAttribute('section-id') === this.getAttribute('section-id')
          );
          const nextGrid = section?.querySelector('[data-blog-grid]');
          const nextPagination = section?.querySelector('[data-blog-pagination]');
          if (!nextGrid || !nextPagination) throw new Error('Invalid blog response');
          const existing = new Set(Array.from(this.grid.children, (item) => item.dataset.articleId));
          const items = Array.from(nextGrid.children).filter(
            (item) => item.hasAttribute('data-article-id') && !existing.has(item.dataset.articleId)
          );
          if (!items.length) throw new Error('No new posts returned');
          const nextLink = nextPagination.querySelector('[data-blog-next]');
          if (nextLink?.getAttribute('href') === link.getAttribute('href')) throw new Error('Repeated page');
          this.grid.append(...items);
          this.pagination.replaceChildren(...nextPagination.childNodes);
          this.status.textContent = nextLink ? `${items.length} more posts loaded.` : 'All posts have been loaded.';
          // Only move focus following an explicit click, never during scrolling.
          if (manual) {
            const firstLink = items[0].querySelector('a[href]');
            firstLink?.focus({ preventScroll: true });
          }
          success = true;
        } catch (error) {
          if (this.isConnected && this.controller === controller) {
            this.status.textContent = 'Could not load more posts. Select “Load more posts” to try again.';
          }
        } finally {
          clearTimeout(timeout);
          if (this.controller === controller) {
            this.loading = false;
            this.grid.removeAttribute('aria-busy');
            link.removeAttribute('aria-disabled');
            if (success && this.isConnected) this.observeNext();
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
